module.exports = __webpack_public_path__ + "54cf98f5/img/cadBim.e369a02a.png";